export interface AuthTokens {
  accessToken: string;
  idToken: string;
  infoToken: string;
}

export const getLocalToken = (): AuthTokens | null => {
  const storedTokens = localStorage.getItem("tokens");

  return storedTokens ? (JSON.parse(storedTokens) as AuthTokens) : null;
};

export const setLocalToken = (tokens: AuthTokens) => {
  localStorage.setItem("tokens", JSON.stringify(tokens));
};

export function clearTokensLocalStorage() {
  localStorage.removeItem("tokens");
}

export const checkTokenExpiration = (token: string): boolean => {
  if (!token) return true;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const { exp } = JSON.parse(jsonPayload);
    const nowInSeconds = Math.floor(Date.now() / 1000);
    return exp < nowInSeconds;
  } catch {
    return true;
  }
};
